import React, { useEffect, useState } from 'react'
import { Card, Spacer, Collapse, Divider } from '@cleartrip/bento'

import { Target } from 'components/composite'
import { IconMap, List, LinkIconMap } from 'components/travelsafe'
import classNames from 'classnames'
import { CATEGORY_MAP, TEST_TYPES, CONDITION } from 'constants/travelsafe'
import { align } from "helper/flyin";
import { langTranslate } from "helper/arabic";
import { ReactComponent as Restriction } from 'assets/icons/restriction.svg'
import { ReactComponent as Chevron } from 'assets/icons/chevron.svg';

function SummaryCard(props) {
	const {
		title,
		description,
		sourceLink,
		sourceText,
		additionalDescription,
		additionalLinks,
		testWindow,
		category,
		subCategory,
		lastUpdated,
	} = props

	const CHAR_LENGTH = 140
	let [stringLength, setStringLength] = useState(CHAR_LENGTH)
	let [collapsed, setCollapsed] = useState(true)
	let isDisableViewDetails = true
	if (description.length >= stringLength || additionalDescription || additionalLinks || lastUpdated)
		isDisableViewDetails = false
	else isDisableViewDetails = true

	let truncatedDescription = description.substr(0, stringLength)
	let additionalDescriptionList  = additionalDescription && additionalDescription.split('\n')
	let additionalDescriptionBlock = ''
	if(additionalDescriptionList) {
		additionalDescriptionBlock = additionalDescriptionList.map((list, idx, listArray) => {
			if (idx === 0 && listArray.length > 1) {
				return <><p style={{lineHeight: 1.5}} className="fs-3 fs-3--xs c-neutral-700 lh-copy pb-1">{list}</p></>;
			} else {
				return <p style={{lineHeight: 1.5}} className="fs-3 fs-3--xs c-neutral-700 lh-copy">{list}</p>;
			}
		});
	}


	useEffect(() => {
		if (collapsed) setStringLength(CHAR_LENGTH)
		else setStringLength(description.length)
	}, [collapsed])

	function onCardExpand() {
		setCollapsed(!collapsed)
	}

	// function getViewHideDetails() {
	// 	if (align==="rtl")
	// 	 return collapsed ? 'عرض التفاصيل' : 'يخفي التفاصيل'
		
	// 	 return collapsed ? 'View details' : 'Hide details'
	// }

	//Switch case statement for card category

	let iconWrapperClass = classNames(
		'flex flex-middle flex-center br-100',
		{
			'bg-error-100': category === CATEGORY_MAP.NO_ENTRY || category === CATEGORY_MAP.NO_EXIT,
			'bg-success-100': category === CATEGORY_MAP.ENTRY || category === CATEGORY_MAP.EXIT,
			'bg-warning-100': category === CATEGORY_MAP.RESTRICTED_ENTRY || category === CATEGORY_MAP.RESTRICTED_EXIT,
		},
		'bg-secondary-100'
	)

	let iconClass = classNames('c-secondary-500', {
		'c-error-500': category === CATEGORY_MAP.NO_ENTRY || category === CATEGORY_MAP.NO_EXIT,
		'c-success-500': category === CATEGORY_MAP.ENTRY || category === CATEGORY_MAP.EXIT,
		'c-warning-500': category === CATEGORY_MAP.RESTRICTED_ENTRY || category === CATEGORY_MAP.RESTRICTED_EXIT,
	})

	function getTestngType(key) {
		if(!key) return '';
		return (TEST_TYPES[key] ? TEST_TYPES[key] : key);
	}

	function getTestngCondition(key) {
		if(!key) return '';
		return (CONDITION[key] ? CONDITION[key] : '');
	}

	let ContentBlock = (
		<>
			<p style={{ lineHeight: 1.5 }} className='fs-3 fs-3--xs c-neutral-700 lh-copy'>
				{truncatedDescription}
				{description.length > stringLength && collapsed ? '...' : ''}
			</p>
			{/* Links */}
			<div>
			{additionalLinks && additionalLinks.length !== 0 && (
				<div>
							<div className="flex flex-start flex-wrap pt-4 d-none--xs">
								<Spacer className='pt-4'/>
								{additionalLinks.map((item, idx) => (
									<div className={`flex flex-middle ${align() === "ltr" ? "mr-8" : "ml-8"}`}>
										<div className="c-secondary-500">
											<LinkIconMap type={item.type} className="c-secondary-500 h-3 w-10"/>
										</div>
										<Spacer className="mr-2"/>
										<a target='_blank' className='td-none hover:td-underline lh-copy lh-copy--xs c-neutral-700 hover:c-secondary-500 fw-500' style={{fontSize: '14px', fontWeight: '400'}} key={idx} href={item.url}>
											{!item.title ? langTranslate("See details") : item.title}
										</a>
										<Spacer className='mr-2'/>
										{additionalLinks.length - 1 !== idx && <Spacer className='pt-1' />}
									</div>
								))}
							</div>
							<div className="flex flex-column d-none d-block--xs">
								<Spacer className='pt-3'/>
								{additionalLinks.map((item, idx) => (
									<div className="flex flex-middle mb-2">
										<div className="c-secondary-500">
											<LinkIconMap type={item.type} className="c-secondary-500 h-3 w-10"/>
										</div>
										<Spacer className="mr-2"/>
										<a target='_blank' className='td-none hover:td-underline lh-copy lh-copy--xs c-secondary-500' style={{fontSize: '14px', fontWeight: '400'}} key={idx} href={item.url}>
											{!item.title ? langTranslate("See details") : item.title}
										</a>
										<Spacer className='mr-2'/>
										{additionalLinks.length - 1 !== idx && <Spacer className='pt-1' />}
									</div>
								))}
							</div>
							</div>
			)}
			</div>
			{additionalDescriptionBlock && <Collapse pose={collapsed ? 'collapsed' : 'open'}>
				<Spacer className='pt-2' />
				{/* <p style={{ lineHeight: 1.5 }} className='fs-4 c-neutral-700 lh-copy'>
					{additionalDescription}
				</p> */}
				<div className="c-neutral-700 fw-600 fs-3 fs-3--xs mb-1 mt-4">{langTranslate('Details and Exemptions')}</div>
				{additionalDescriptionBlock}
				{testWindow ?
					<>
						<p className="fs-3 fs-3--xs pt-8 c-neutral-700 fw-600">{langTranslate('Testing Types')}</p>
						{testWindow.map((item, idx) => {
							return (
								<div className="flex flex-column mt-3 fs-3 fs-3--xs">
									<p className="tt-capitalize c-neutral-700 fs-3 fs-3--xs">{getTestngType(item.medicalRequirementType)}</p>
									<p className="tt-capitalize c-neutral-400 fs-3 fs-3--xs">{`${item.text} ${getTestngCondition(item.condition)}`}</p>
								</div>
							);
						})}
					</>
					 : null}
			</Collapse>}
		</>
	);

	return (
		<>
			<Card
				className="t-all ba bc-neutral-100 br-4 pt-4 pl-4 pr-4 pb-3 c-pointer flex flex-top d-none--xs hover:elevation-3"
				onClick={description.length < stringLength && !additionalDescriptionBlock ? () => {} : !isDisableViewDetails ? onCardExpand : null}
			>
				<span>
					<div className={iconWrapperClass} style={{ height: '42px', width: '42px' }}>
						<IconMap icon={category} className={iconClass} style={{height: '20px', width: '20px'}}/>
					</div>
				</span>
				<Spacer className="mr-5" />
				<div className="flex flex-column flex-between w-100p flex-1">
					<div>
						<p className="fs-4 fw-600 c-neutral-900">{title}</p>
						<Spacer className="pt-1" />
						{ContentBlock}
						
					</div>
					<Divider className="bc-neutral-0 mt-4 mb-3"/>
					<div className="flex flex-between flex-bottom">
						<p
							className={classNames('fs-2', {
								'c-secondary-500 c-pointer hover:td-underline': !isDisableViewDetails,
								'c-neutral-100 c-not-allowed': isDisableViewDetails,
							})}
							onClick={!isDisableViewDetails ? onCardExpand : null}
						>
							{description.length < stringLength && !additionalDescriptionBlock ? '' : collapsed ? 
								<div className="flex flex-middle"><div className="c-secondary-500 fw-600 fs-2">{langTranslate('View details')}</div><Chevron height={12} width={12} style={{height: '10px', width: '10px'}} className={`chevron c-secondary-500 ${align() === "ltr" ? "ml-1" : "mr-1"}`}/></div>
								: <div className="flex flex-middle"><div className="c-secondary-500 fw-600 fs-2">{langTranslate('Hide details')}</div><Chevron height={12} width={12} style={{transform: 'rotate(180deg)', height: '10px', width: '10px'}} className={`chevron c-secondary-500 ${align() === "ltr" ? "ml-1" : "mr-1"}`}/></div>}
						</p>
						<div className="flex flex-middle">
							<p className="fs-2 c-neutral-400">
								{langTranslate("Source")}:{' '}
								{sourceLink ? (
									<Target
										href={sourceLink}
										style={{ fontSize: '12px', fontWeight: 400 }}
										iconSize={10}
										className="c-neutral-400 c-pointer hover:c-secondary-500 fw-400"
										blank
									>
										{sourceText}
									</Target>
								) : (
									<span className="c-neutral-400">{langTranslate('NA')}</span>
								)}
							</p>
						</div>
					</div>
				</div>
			</Card>

			{/* //Mobile version */}
			<Card className="d-none d-block--xs ba bc-neutral-100 br-4 mx-4--xs" onClick={description.length < stringLength && !additionalDescriptionBlock ? () => {} : !isDisableViewDetails ? onCardExpand : null}>
				<div className="flex flex-middle pr-4 pl-3 pb-3 pt-3">
					<span>
						<div className={iconWrapperClass} style={{ height: '28px', width: '28px' }}>
							<IconMap height={16} width={16} icon={category} className={iconClass} />
						</div>
					</span>
					<Spacer className="pr-3" />
					<p className="fs-4 fw-600 c-neutral-900">{title}</p>
				</div>
				<Divider className="bc-neutral-0" />
				<div className="px-4 pt-4 pb-3">
					{ContentBlock}
					<Divider className="bc-neutral-0 mt-4 mb-3"/>
					<div className="flex flex-middle flex-between">
						<p className="fs-2 c-neutral-400">
							{!collapsed ? langTranslate("Source") : null}
							{sourceLink ? (
								<Target
									href={sourceLink}
									style={{ fontSize: '12px', fontWeight: 400 }}
									iconSize={8}
									className="c-neutral-400 c-pointer hover:c-secondary-500"
									blank
								>
									{sourceText && sourceText.length > 27 ? `${sourceText.substr(0,27)}...` : sourceText}
								</Target>
							) : (
								<span className="c-neutral-400">{langTranslate('NA')}</span>
							)}
						</p>
						<p
							className={classNames('fs-2', {
								'c-secondary-500 c-pointer hover:td-underline': !isDisableViewDetails,
								'c-neutral-100 c-not-allowed': isDisableViewDetails,
							})}
							onClick={!isDisableViewDetails ? onCardExpand : null}
						>
							{description.length < stringLength && !additionalDescriptionBlock ? '' : collapsed ? langTranslate('View details') : langTranslate('Hide details')}
						</p>
					</div>
				</div>
			</Card>
		</>
	)
}

export default SummaryCard
